module.exports = __webpack_public_path__ + "static/media/aboutusvideomobile.40455298.mp4";